/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureIndicatorInfo } from '../models/FeatureIndicatorInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FeatureControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns FeatureIndicatorInfo OK
     * @throws ApiError
     */
    public getFeatureIndicator(): CancelablePromise<Array<FeatureIndicatorInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/feature/indicator',
        });
    }

}
